/**
 * The minimum-markup DNE rule (VE-DNE): a vendor estimate can't be approved when vendor amount + the customer's
 * minimum profit is above the customer's revised DNE. Only APPROVAL is blocked (422 DNE_BLOCKED, the message
 * explains the numbers); countering, saving and sending are never refused by this rule and there is no reason
 * to enter. The admin chooses whether only this vendor's estimate counts ("Keep one vendor") or every vendor's
 * estimate on the job ("Keep all vendors"). The choice is not stored.
 */
export const DNE_BLOCKED = 'DNE_BLOCKED';

export interface DneRuleRequestFields {
  keepAllVendors?: boolean;
}

type ResponseLike =
  | {
      details?: ReadonlyArray<unknown> | null;
      /** V1 JobOpsChat JSON uses an error string instead of details. */
      error?: string | null;
    }
  | null
  | undefined;

/** 'blocked' when the server refused an approve with DNE_BLOCKED, else null. */
export function dneOutcome(res: ResponseLike): 'blocked' | null {
  if (!res) return null;
  const codes = (Array.isArray(res.details) ? res.details : []).map((d) =>
    String((d as { code?: unknown } | null)?.code ?? '').toUpperCase(),
  );
  const v1 = (res.error ?? '').toLowerCase();
  return codes.includes(DNE_BLOCKED) || v1 === 'dne_blocked' ? 'blocked' : null;
}
